/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useSelector } from 'react-redux';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import SearchLei from 'components/atoms/search_lei';
import ListLei from 'components/molecules/list_lei';
import OpenTutorial from 'components/atoms/open_tutorial';

const Legislation = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    document.title = 'Jurídico Fácil - Licitações - ConLicitação';
  }, []);

  return (
    <div className="page-container p-4">
      {profile.paralyzed ? (
        <BlockedSubscription paralyzed={profile.paralyzed} />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="d-md-flex d-block align-items-center mb-3">
                <h4 className="mb-1 mr-3 font-weight-bold">Jurídico Fácil</h4>
                <OpenTutorial type="modal" source="juridico" />
              </div>
              <p className="lead font-weight-normal">
                As principais Legislações e Decretos que regulamentam e estabelecem as Licitações e
                contratos administrativos.
              </p>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/juridico">Inicio</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leis
                  </li>
                </ol>
              </nav>
              <SearchLei params={[]} />
              <ListLei />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Legislation;
